import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { AssessmentService } from 'app/shared/services/assessment.service';
import { Assessment } from 'app/shared/models/assessment';
import { Scale } from 'app/shared/models/scale';

@Component({
  selector: 'dac-scales-list-view',
  templateUrl: './scales-list-view.component.html',
  styleUrls: ['./scales-list-view.component.css']
})
export class ScalesListViewComponent implements OnInit, OnChanges {

  @Input() assessment:Assessment;
  public selectedScale:Scale;
  
  constructor() { 
  }

  getClassesForScale(scale:Scale) {
    let isSelected = scale == this.selectedScale;
    let classes = {
      'primary-color': isSelected
      ,'white-text': isSelected
    };
    return classes;
  }

  ngOnChanges() {
    this.populateScaleFromAssessment(this.assessment);
  }
  ngOnInit() {
    this.populateScaleFromAssessment(this.assessment);
  }

  private populateScaleFromAssessment(assessment:Assessment) {
    if (!assessment) {
      return;
    }
    
    if (assessment.scales.length) {
      this.selectedScale = assessment.scales[0];
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/scales-list-view/scales-list-view.component.ts